import React from 'react';

const ActionButtons = ({ coin, mode, onSendClick, onReceiveClick, onPrivateTransferClick, onShieldUnshieldClick }) => {
  if (!coin) return null;

  const hasActiveTransaction = !!coin.transactionStatus;
  const isTransactionInProgress = hasActiveTransaction &&
    (coin.transactionStatus.status === 'PENDING' || coin.transactionStatus.status === 'IN_PROGRESS');

  return (
    <>
      <div className='flex items-center gap-2 justify-center'>
        {mode === 'private' ? (
          // Private mode - Internal Transfer and Unshield
          <div className="d-flex gap-2 mt-3 mb-2 flex-wrap">
            <button
              className="modal-button flex items-center gap-2 justify-content-center primary"
              onClick={onPrivateTransferClick}
              disabled={isTransactionInProgress}
              style={{
                flex: 'none',
                minWidth: '134px',
                opacity: isTransactionInProgress ? 0.5 : 1,
                cursor: isTransactionInProgress ? 'not-allowed' : 'pointer'
              }}
            >
              {isTransactionInProgress ? 'Transaction in Progress...' : 'Private Transfer'}
            </button>
            {!isTransactionInProgress && (
              <button
                className="modal-button flex items-center gap-2 justify-content-center primary"
                onClick={onShieldUnshieldClick}
                style={{
                  flex: 'none',
                  minWidth: '170px'
                }}
              >
                Unshield
              </button>
            )}
          </div>
        ) : (
          // Public mode - Send, Receive, and Shield
          <div className="d-flex gap-2 mt-3 mb-2 flex-wrap">
            <button
              className="modal-button flex items-center gap-2 justify-content-center primary"
              onClick={onSendClick}
              disabled={isTransactionInProgress}
              style={{
                flex: 'none',
                minWidth: '134px',
                opacity: isTransactionInProgress ? 0.5 : 1,
                cursor: isTransactionInProgress ? 'not-allowed' : 'pointer'
              }}
            >
              {isTransactionInProgress ? 'Transaction in Progress...' : 'Send'}
            </button>
            <button
              className="modal-button flex items-center gap-2 justify-content-center primary"
              onClick={onReceiveClick}
              disabled={isTransactionInProgress}
              style={{
                flex: 'none',
                minWidth: '134px',
                opacity: isTransactionInProgress ? 0.5 : 1,
                cursor: isTransactionInProgress ? 'not-allowed' : 'pointer'
              }}
            >
              Receive
            </button>
            {!isTransactionInProgress && (
              <button
                className="modal-button flex items-center gap-2 justify-content-center primary"
                onClick={onShieldUnshieldClick}
                style={{
                  flex: 'none',
                  minWidth: '134px'
                }}
              >
                Shield
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ActionButtons;